import {Alert,CloseButton,Text,Group} from "@mantine/core";
import React from "react";

const CustomToast = ({alert,onHide}) =>{
   return   <Alert title="" color={alert?.action === 'success' ? "green":"red"} m={2} p={2}>
      <Group position="apart">
         <Text mx={10}>{alert?.message ||'Test'}</Text>
         <CloseButton onClick={onHide} />
      </Group>
 </Alert>
}
export default CustomToast;
